import React from 'react';
import { useTranslation } from 'react-i18next';
import { apiService } from '../../../api/apiClient';
import AuditFiltersBar from '../AuditFiltersBar';
import AuditTable, { statusPill, formatTs, monoShort } from '../AuditTable';
import InfoBox from '../InfoBox';
import useAuditList from '../useAuditList';

export default function TracesTab({ onOpenTrace }) {
  const { t } = useTranslation();
  const { rows, loading, filters, setFilters, offset, limit, next, prev } =
    useAuditList(apiService.listAuditTraces);

  const columns = [
    { key: 'started_at', header: t('traceability:columns.startedAt'), render: (r) => formatTs(r.started_at) },
    { key: 'ended_at', header: t('traceability:columns.endedAt'), render: (r) => formatTs(r.ended_at) },
    { key: 'kind', header: t('traceability:columns.kind') },
    { key: 'actor', header: t('traceability:columns.actor') },
    { key: 'status', header: t('traceability:columns.status'), render: (r) => statusPill(r.status) },
    { key: 'latency_ms', header: t('traceability:columns.latency') },
    { key: 'event_count', header: '#events' },
    { key: 'id', header: t('traceability:columns.traceId'),
      render: (r) => monoShort(r.id, 12) },
  ];

  return (
    <div>
      <InfoBox tabKey="traces" />
      <AuditFiltersBar value={filters} onChange={setFilters} showTraceId={false} />
      <AuditTable rows={rows} columns={columns} loading={loading}
                  limit={limit} offset={offset} onNext={next} onPrev={prev}
                  onRowClick={(r) => onOpenTrace(r.id)} />
    </div>
  );
}
